import { InjectionToken, InjectOptions, Injector, Type } from '@angular/core';

// We need this so that we can pass in DialogRef in the DialogComponent,
// to gain access to close() method and emit onClose value
export class DialogInjector implements Injector {
  constructor(
    private parentInjector: Injector,
    private additionalTokens: WeakMap<any, any>,
  ) {}

  get<T>(
    token: Type<T> | InjectionToken<T>,
    notFoundValue?: T,
    options?: InjectOptions,
  ): T;

  get(token: any, notFoundValue?: any): any;

  get(token: any, notFoundValue?: any, options?: InjectOptions): any {
    const value = this.additionalTokens.get(token);

    if (value) {
      return value;
    }

    return this.parentInjector.get<any>(token, notFoundValue, options);
  }
}
